import React from 'react';
import { Trash } from 'lucide-react';
import { useCourseData } from '@/pages/Course';
import { useCourses } from '@/features/course/hooks/useCourses';

function DeletedTopic({ unitId, title }) {
  const { user, course, isAdmin } = useCourseData();
  const { updateCourses } = useCourses();

  const handleDelete = async () => {
    const updatedUnits = course.units.map((unit) => {
      if (unit._id === unitId) {
        return {
          ...unit,
          topics: unit.topics.filter((topic) => topic.name !== title.name),
        };
      }
      return unit;
    });

    const updatedCourse = {
      units: updatedUnits,
    };

    try {
      await updateCourses.mutateAsync({
        id: course._id,
        updatedData: updatedCourse,
      });
    } catch (error) {
      console.error('Error deleting topic:', error);
    }
  };

  return (
    <>
      {isAdmin && (
        <button onClick={handleDelete}>
          <Trash className="hover:text-slate-400 font-bold" size={18} />
        </button>
      )}
    </>
  );
}

export default DeletedTopic;
